<template>
    <div :class="[ifBK?'wrap':'',ifsquare?'xxx_c':'']">
        <slot name="v">
            <!-- <div id="echart_first_xx"></div> -->
        </slot>
        <!-- 方块 -->
        <div :class="[ifsquare?'square1':'']"></div>
        <div :class="[ifsquare?'square2':'']"></div>
    </div>
</template>

<script>
import echarts from "echarts";
import func from '../utils/func'
import {EventBus} from '../utils/eventBus'
export default {
    name: "",
    data() {
        return {
        };
    },
    props: {
        ifBK:{
            type:Boolean,
            default: true
        },
        ifsquare:{
            type:Boolean,
            default: true
        },
    },
    methods: {
        getToken() {
            let formData = new FormData();
            formData.append("username", "dongxiang");
            formData.append("password", "dxq!@123456@!");
            this.$post(this.urlobj.dx_dl, formData).then((res) => {
                localStorage.token = res.newPrimaryKeys.token;
                this.$store.commit("updateToken", res.newPrimaryKeys.token);

                this.$emit('getData',func(),echarts,this.bigData)
            });
        },
    },
    computed: {
        bigData() {
            return EventBus.year
        },
    },
    watch: {
        bigData() {
            this.getToken();
        },
    },
    mounted() {
        this.$nextTick(()=>{
            this.getToken();
        })
    },
};
</script>

<style lang="less" scoped>
.wrap {
    box-shadow: 0px 0px 3px 3px #0d3b91 inset;
    border: 1px solid #17D1FE;
    border-radius: 12px;
}
.square1 {
    background: #1AD0FE;
    width: 7px;
    height: 7px;
    position: absolute;
    top: 5px;
    left: 7px;
}
.square2 {
    background: #1AD0FE;
    width: 7px;
    height: 7px;
    position: absolute;
    top: 5px;
    right: 7px;
}
.xxx_c {
    position: relative;
}
</style>
